import { isFlagOn } from '@/lib/envFlag'

export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL
export const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;
export const SUPABASE_EDGE_FUNCTIONS_URL = import.meta.env.VITE_SUPABASE_EDGE_FUNCTIONS_URL;
export const SUPABASE_LOCAL_STORAGE_KEY = import.meta.env.VITE_SUPABASE_LOCAL_STORAGE_KEY;
export const ENV = import.meta.env.VITE_ENV;
export const TEST = import.meta.env.VITE_TEST;
export const IS_TEST = String(import.meta.env.VITE_TEST).toLowerCase() === 'true';

/**
 * Build of the public demo: access code instead of login, read only, reads the
 * `demo` schema. The variable name predates the demo schema; it is the one set
 * on the demo's Vercel project.
 */
export const IS_DEMO_MODE = isFlagOn(import.meta.env.DUMMY_BENEFICIARY_ONLY)
